// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2MjJb","right":"styles_right__1rbYa"};